import { feedFactoryAxios } from "helpers";

export const postMemo = (eventId: string, memo: string) => {
  return feedFactoryAxios.post(`/events/${eventId}/comments`, {
    body: memo,
  });
};
